import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { MessageCircle, X } from 'lucide-react';
const painPoints = ["Te preguntan '¿precio?' y después de tu respuesta… silencio.", 'Respondés rápido, sos amable, explicás todo… y aun así no compran.', 'Te clavan el visto después de pasar la info.', "Te dicen 'lo tengo que hablar' y nunca más vuelven.", 'Sentís que rogás cada vez que hacés follow-up.'];
export function ProblemSection() {
  return <Section background="white" data-id="element-102">
      <div className="text-center mb-12" data-id="element-103">
        <h2 className="font-serif text-3xl md:text-4xl text-[#2D2D2D] mb-4" data-id="element-104">
          ¿Te suena familiar?
        </h2>
        <div className="w-24 h-1 bg-[#C5A55A] mx-auto" data-id="element-105" />
      </div>

      <div className="max-w-3xl mx-auto space-y-6" data-id="element-106">
        {painPoints.map((point, index) => <motion.div key={index} initial={{
        opacity: 0,
        x: index % 2 === 0 ? -20 : 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className={`flex ${index % 2 === 0 ? 'justify-start' : 'justify-end'}`} data-id="element-107">
            <div className={`
              max-w-[85%] md:max-w-[70%] p-4 rounded-2xl shadow-sm relative
              ${index % 2 === 0 ? 'bg-white text-[#2D2D2D] rounded-bl-none border border-gray-100' : 'bg-[#F5F0E8] text-[#2D2D2D] rounded-br-none border border-[#E8E0D5]'}
            `} data-id="element-108">
              <div className="flex items-start gap-3" data-id="element-109">
                <div className={`mt-1 min-w-[20px] ${index % 2 === 0 ? 'text-gray-400' : 'text-[#C5A55A]'}`} data-id="element-110">
                  <MessageCircle size={20} data-id="element-111" />
                </div>
                <p className="text-base md:text-lg leading-relaxed" data-id="element-112">{point}</p>
              </div>
            </div>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.5
    }} className="mt-16 text-center" data-id="element-113">
        <p className="text-xl md:text-2xl font-serif text-[#2D2D2D] italic border-l-4 border-[#C5A55A] pl-6 inline-block max-w-2xl" data-id="element-114">
          "No es el precio. No es la crisis. Es la falta de un camino claro en
          tus DMs."
        </p>
      </motion.div>
    </Section>;
}